<template>
  <div>
    <el-table :data="table" v-loading="loading" stripe size="mini">
      <el-table-column
        sortable
        :show-overflow-tooltip="true"
        align="center"
        prop="recommendNo"
        label="推荐单号"
        width="120"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="recommendTitle"
        label="推荐标题"
        min-width="140"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="custName"
        label="客户名称"
        min-width="120"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="prjTitle"
        label="项目名称"
        min-width="160"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="endDate"
        label="结束日期"
        min-width="120"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="recommendStatusName"
        label="推荐单状态"
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="scope.row.recommendStatusName === '新增' ? 'danger' : 'success'"
          >{{scope.row.recommendStatusName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="recommendDescription"
        label="推荐说明"
        min-width="160"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="modifyDate"
        label="修改日期"
        width="140"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="prjTitle"
        label="修改人员"
        width="140"
      ></el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </div>
    </el-table>
    <!--分页-->
    <p></p>
    <template>
      <js-pagination
              :current-page="page.curPage"
              :page-size="page.pageSize"
              :page-total="page.pageTotal"
              align="left"
              @change="handlePaginationChange"
      />
<!--      <el-pagination-->
<!--        background-->
<!--        :current-page="page.curPage"-->
<!--        :page-size="page.pageSize"-->
<!--        :total="page.total"-->
<!--        @size-change="sizeChange"-->
<!--        @current-change="currentChange"-->
<!--        layout="total, sizes, prev, pager, next, jumper, ->, slot"-->
<!--      ></el-pagination>-->
    </template>
  </div>
</template>

<script>
// import { getList } from '@api/projectManager/infoCustomerRecommend'

export default {
  props: {
    loading: {
      default: false
    },
    params: {
      default: null,
      type: Object
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler (val) {
        if (this.autoLoad) {
          this.getData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      },
      table: [],
      // params: {
      //   prjCode: 'd978eadf-94ce-11ea-a357-000c29540cfd'
      // },
      page: {
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    load (params) {
      this.getData(params)
    },
    getData (params) {
      this.$api.customerRecommendListApi({
        ...params || this.params,
        ...this.page
      }).then(res => {
        this.page.pageTotal = res.body.count
        // this.page.total = res.body.count
        // this.page.curPage = res.body.curPage
        // this.page.pageSize = res.body.pageSize
        this.loading = false
        this.table = res.body.data
      }).catch(() => {
        this.loading = false
      })
    },
    handlePaginationChange (val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.getData()
    },
    sizeChange (val) {
      this.page.curPage = 1
      this.page.pageSize = val
      this.getData()
    },
    currentChange (val) {
      this.page.curPage = val
      this.getData()
    }
  }
}
</script>
